import { render, staticRenderFns } from "./AppointmentReportPreview.vue?vue&type=template&id=93a531b0&scoped=true&"
import script from "./AppointmentReportPreview.vue?vue&type=script&lang=js&"
export * from "./AppointmentReportPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a531b0",
  null
  
)

export default component.exports